import departmentService from "../services/departmentService";
import h from "../services/h";
import constants from "../constants";

export default {
  data() {
    return {
      departments: [],
      departmentTree: [],
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE
    }
  },

  methods: {

    getNodeLabel(node) {
      let nodeType = node.nodeType;
      switch (nodeType) {
        case this.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          return node.department.deptName || "-";
        case this.DEPARTMENT_TREE.NODE_TYPE.BTGD:
          return "Ban Tổng giám đốc";
        case this.DEPARTMENT_TREE.NODE_TYPE.HDTV:
          return "Hội đồng thành viên";
        case this.DEPARTMENT_TREE.NODE_TYPE.DVTT:
          return "Đơn vị trực thuộc";
        case this.DEPARTMENT_TREE.NODE_TYPE.PBCN:
          return "Phòng ban chức năng";
        case this.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT:
          return "HĐTV, Ban Tổng giám đốc";
        default:
          return "-";
      }
    },

    filterDepartmentTreeNode(value, data) {
      return !value ? true : (this.buildDepartmentLabel(data.department) || "").toUpperCase().indexOf(value.toUpperCase()) !== -1;
    },

    buildDepartmentLabel(department) {
      return department ? `${department.deptName} - ${department.identityCode} (${department.parentName})` : null;
    },

    loadDepartments() {
      return departmentService
        .findAll({sort: "path,asc", status: constants.DEPARTMENT.STATUS.ACTIVE})
        .then(response => {
          this.departments = response.data;
          this.buildDepartmentTree();
        })
    },

    buildDepartmentTree() {
      h.each(this.departments, (item) => {
        (!item.parentId) && this.departmentTree.push(
          this.buildDepartmentTreeForNode(this.buildDataForNode(item))
        );
      })
    },

    buildDataForNode(department) {
      return {department: department, checked: false, nodeType: this.DEPARTMENT_TREE.NODE_TYPE.DEPT};
    },

    getDeptTypeByNodeType(nodeType) {
      switch (nodeType) {
        case this.DEPARTMENT_TREE.NODE_TYPE.DVTT:
          return constants.DEPARTMENT.DEPT_TYPE.DVTT;
        case this.DEPARTMENT_TREE.NODE_TYPE.PBCN:
          return constants.DEPARTMENT.DEPT_TYPE.PBCN;
        default:
          return null;
      }
    },

    buildDepartmentTreeForNode(node) {

      if (node && node.nodeType == this.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
        let department = node.department;
        /**
         * nếu là node TCT thì build thành 2 node trung gian phòng-ban-chức-năng & đơn-vị-trực thuộc
         */
        if (department.deptCode == this.$store.getters.globalRoles) {

          node.children = [];

          const pbcnDeptType = this.getDeptTypeByNodeType(this.DEPARTMENT_TREE.NODE_TYPE.PBCN);
          const dvttNodeType = this.getDeptTypeByNodeType(this.DEPARTMENT_TREE.NODE_TYPE.DVTT);
          let childrenDepartments = h.findAll(this.departments, (item) =>
            item.parentId == department.id && [pbcnDeptType, dvttNodeType].indexOf(item.deptType) == -1
          );
          h.each(childrenDepartments, (item) =>
            node.children.push(this.buildDepartmentTreeForNode(this.buildDataForNode(item)))
          );

          node.children.push(...[
            this.buildDepartmentTreeForNode({nodeType: this.DEPARTMENT_TREE.NODE_TYPE.PBCN, department: department}),
            this.buildDepartmentTreeForNode({nodeType: this.DEPARTMENT_TREE.NODE_TYPE.DVTT, department: department}),
          ]);

        } else {
          let departmentId = department.id;
          let childrenDepartments = h.findAll(this.departments, (item) => item.parentId == departmentId);
          node.children = h.collect(childrenDepartments, (item) =>
            this.buildDepartmentTreeForNode(this.buildDataForNode(item))
          );
        }
      } else {
        let department = node.department;
        let childrenDepartments = h.findAll(this.departments, (item) =>
          item.parentId == department.id && item.deptType == this.getDeptTypeByNodeType(node.nodeType)
        );
        node.children = h.collect(childrenDepartments, (item) =>
          this.buildDepartmentTreeForNode(this.buildDataForNode(item))
        );
      }

      return node;
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/displayDepartmentTreeMixin.js